import Helpers from "../../Config/Helpers";
import { Box, Typography } from "@mui/material";

function Footer() {
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      className="footer"
      sx={{
        position: "fixed",
        bottom: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.drawer - 1,
        background: "#ffffff",
        borderTop: "1px solid #e9ecf0",
        boxShadow: "0 -1px 8px rgba(102,126,234,0.06)",
        py: 1.25,
        px: { xs: 2, sm: 3 },
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 1,
        minHeight: 48,
      }}
    >
      {/* Left — copyright */}
      <Typography
        variant="body2"
        sx={{
          ml: "auto",
          color: "#667788",
          fontSize: "0.78rem",
          fontWeight: 500,
        }}
      >
        © {year}{" "}
        <Box
          component="span"
          sx={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontWeight: 700,
          }}
        >
          {Helpers.appName}
        </Box>
        . All rights reserved.
      </Typography>

      {/* Right — made with love */}
      {/* <Typography
        variant="body2"
        sx={{
          color: "#98a2b3",
          fontSize: "0.75rem",
          display: "flex",
          alignItems: "center",
          gap: 0.4,
        }}
      >
        Made with{" "}
        <FavoriteIcon
          sx={{
            fontSize: 12,
            color: "#0daf30",
            animation: "heartbeat 1.4s ease infinite",
            "@keyframes heartbeat": {
              "0%, 100%": { transform: "scale(1)" },
              "50%": { transform: "scale(1.25)" },
            },
          }}
        />{" "}
        by{" "}
        <Box
          component="span"
          sx={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontWeight: 600,
          }}
        >
          {Helpers.appName}
        </Box> 
      </Typography>*/}
    </Box>
  );
}

export default Footer;
